import API from "./api";
import { Data } from "./global";

export default class Host {
    data;

    constructor(){
        this.data = null;
    }

    async getData(){
        try {
            this.data = await API.GET('/public/web', false);
            Data.setESList(this.data.esList);
        }catch(err){
            console.error('Failed to get host data: ' + err.message);
        }
    }

    getTitle(){
        return this.data?.title || "???";
    }
}

export const host = new Host();